import { Box } from "@mui/material";
import React from "react";
import ReactApexChart from "react-apexcharts";

const BarChart = (props) => {
    // const data = props.data
    const data = {
        "01/08/2023": {
          received: 25,
          released: 18,
        },
        "02/08/2023": {
          received: 30,
          released: 20,
        },
        "03/08/2023": {
          received: 20,
          released: 15,
        },
        "04/08/2023": {
          received: 27,
          released: 17,
        },
        "05/08/2023": {
          received: 32,
          released: 22,
        },
        "06/08/2023": {
          received: 21,
          released: 18,
        },
        "07/08/2023": {
          received: 36,
          released: 25,
        },
        "08/08/2023": {
          received: 40,
          released: 30,
        },
        "09/08/2023": {
          received: 18,
          released: 12,
        },
        "10/08/2023": {
          received: 25,
          released: 18,
        },
        "11/08/2023": {
          received: 30,
          released: 22,
        },
        "12/08/2023": {
          received: 22,
          released: 17,
        },
        "13/08/2023": {
          received: 29,
          released: 23,
        },
        "14/08/2023": {
          received: 24,
          released: 20,
        },
        "15/08/2023": {
          received: 31,
          released: 25,
        },
        "16/08/2023": {
          received: 28,
          released: 19,
        },
        "17/08/2023": {
          received: 23,
          released: 15,
        },
        "18/08/2023": {
          received: 35,
          released: 28,
        },
        "19/08/2023": {
          received: 26,
          released: 20,
        },
        "20/08/2023": {
          received: 33,
          released: 24,
        },
        "21/08/2023": {
          received: 19,
          released: 15,
        },
        "22/08/2023": {
          received: 30,
          released: 22,
        },
        "23/08/2023": {
          received: 28,
          released: 21,
        },
        "24/08/2023": {
          received: 22,
          released: 18,
        },
        "25/08/2023": {
          received: 37,
          released: 30,
        },
        "26/08/2023": {
          received: 24,
          released: 19,
        },
        "27/08/2023": {
          received: 28,
          released: 23,
        },
        "28/08/2023": {
          received: 33,
          // released: 26,
        },
        "29/08/2023": {
          received: 21,
          released: 16,
        },
        "30/08/2023": {
          received: 30,
          released: 24,
        },
        "31/08/2023": {
          received: 27,
          released: 20,
        },
      };
      
      
  
  const dates = Object.keys(data); // Array of dates
  const receivedItems = Object.values(data).map(entry => entry.received); // Array of received items
  const releasedItems = Object.values(data).map(entry => entry.released); // Array of released items  

  const series = [
    {
      name: "Received",
      data: receivedItems,
    },
    {
      name: "Released",
      data: releasedItems,
    },
  ];
  const options = {
    chart: {
      type: "bar",
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories: dates
    },
    yaxis: {
      title: {
        text: "Count",
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
      },
    },
  };

  return (
    <Box className="w-[100%]">
      <ReactApexChart series={series} options={options} type="bar" height={props.height}/>
    </Box>
  );
};

export default BarChart;
